import React, { useState } from "react";
import { NavigationContainer} from "@react-navigation/native";
import  AppLoading  from 'expo-app-loading'
import navigationTheme from "./app/navigation/navigationTheme";
import OfflineNotice from "./app/components/OfflineNotice";
import AuthNavigator from "./app/navigation/AuthNavigator";
import AuthContext from "./app/auth/context";
import authStorage from "./app/auth/storage";
 import { navigationRef } from "./app/navigation/rootNavigation";
 import NoBottonTabNavigator from "./app/navigation/NoBottonTabNavigator";
import { StyleSheet, View, Dimensions } from "react-native";

export default function App() {

//   useEffect(() => {
  
// }, []);
  const [user, setUser] = useState();
  const [isReady, setIsReady] = useState(false);
//debugger
//Esta variable es para cuando no tengas un usuario registrado
//permita el acceso
  var notREgisterUser = '{"country":"MX","userId":228,"userName":"notUser","email":"","userPhoto":"2021-11-04_19:08:01_photo.jpg","userPassword":"","createDate":"","countryId":"","alias":"notUser"}'
  const restoreUser = async () => {
  const user = await authStorage.getUser();
    if (user){
     // console.log('restoreUser -> user', user, JSON.parse(user).alias)
       setUser(user)
    }
    else{
      // console.log('restoreUser -> notREgisterUser', JSON.parse(user).alias)
      setUser(notREgisterUser)
    }
  };

  if (!isReady)
    return (
      <AppLoading startAsync={restoreUser} onFinish={() => setIsReady(true)} onError={ (error)  => {console.log('console.log de AppLoading error ->' ,error)} }/>
    );
    const windowWidth = Dimensions.get('window').width;
    //const windowHeight = Dimensions.get('window').height;
    // console.log('Dimensions width-> ', windowWidth)
    // console.log('Dimensions higth-> ', windowHeight)

   // http://18.116.234.21:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId=506&screen=ListingsSeedsScreen
    //var shareLink = 'http://18.116.234.21:19006/AppNavigator/Feed/Seed%20Details?item=%5Bobject%20Object%5D&seedId='+ seedId +'&screen=ListingsSeedsScreen' 
    const state = {
      prefixes: [
       'Seed Details' ,
        //'http://18.116.234.21:19006/?'
        'http://localhost:19006/',
        /* your linking prefixes */
      ],
      routes: [
        {
          name: 'Seed Details',
          state: {
            routes: [
              {
                name: 'AppNavigator',
               // item:{ },
                params: { item:{              
                  origin: 0,                  
                  seedId: 452,             
                  type: 0,                
                 } },
              },
            ],
          },
        },
      ],
    };
    const linking = {
      prefixes: [
        //'http://18.116.234.21:19006/?'
        'http://localhost:19006/'
        
        /* your linking prefixes */
      ],
      routes: [
        {
          name: 'CommentsSeeds',
          state: {
            routes: [
              {
                //name: 'Profile',
                params: { idUser: '142' },
              },
            ],
          },
        },
      ],

    };

  return (
    <AuthContext.Provider value={{ user, setUser }}>
      <OfflineNotice />
     
      <NavigationContainer ref={navigationRef} theme={navigationTheme} linking={state}>
      {
        //.................................................................................
        //Sección que mide el monitor para poner margenes a los lados en monitores grandes
        //................................................................................
        windowWidth > 600 ?
        <View style={styles.container}>
          {user ? <NoBottonTabNavigator /> : <AuthNavigator />}
        </View> 
         :
         <>
          {user ? <NoBottonTabNavigator /> : <AuthNavigator />}
         </>
      }            
      </NavigationContainer>
 
    </AuthContext.Provider>
  );
}
const styles = StyleSheet.create({
  container: {
     marginLeft: '30%',
     marginRight: '30%',
    flex:1
  },
});

